(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/payfooter.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/payfooter.js'); 'use strict';

var getMarketplaceAccount = svs.tipset.helpers.getMarketplaceAccount;
var roles = svs.core.userSession.roles;

function tipssmParticipateDialog() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  svs.core.module.load('/cl/sport/tipssm-participate-dialog', null, function () {
    var tipssmParticipateDialog = svs.components.sport.tipssmParticipateDialog.tipssmParticipateDialog;
    tipssmParticipateDialog.apply(void 0, args);
  });
}

function getProductId() {
  return svs.tipset.collections.draws.getCurrentDraw().get('productId');
}

svs.tipset.views.PayFooter = Backbone.Marionette.View.extend({
  template: function template(data) {
    return svs.tipset.templates.payfooter(data);
  },
  id: 'paymentfooter',
  className: 'payment-footer',
  log: new svs.core.log.Logger('svs.tipset.views.PayFooter'),
  events: {
    'click .js-btn-pay': 'onPayClick'
  },
  initialize: function initialize(options) {
    this.model = options.model;
    this.listenTo(this.model, 'change', this.render);
    this.listenTo(this.model, 'change:wager', this.render);
    this.listenTo(this.model, 'change:bombenUpdated', this.render);
    this.listenTo(this.model, 'change:sportkryssChanged', this.render);
  },
  onPayClick: function onPayClick() {
    var marketplaceAccount = getMarketplaceAccount();

    if (marketplaceAccount) {
      this.marketplacePayment(marketplaceAccount);
    } else if (svs.tipset.models.competition && this.model.getIsM64()) {
      this.tipsSMPayment();
    } else {
      this.model.pay();
    }
  },
  marketplacePayment: function marketplacePayment(marketplaceAccount) {
    var _this = this;

    var drawNumber = svs.tipset.collections.draws.getCurrentDraw().get('drawNumber');

    if (new Date(marketplaceAccount.buyinCloseTime).getTime() < Date.now()) {
      this.model.pay();
    } else {
      var _svs$components$marke = svs.components.marketplace.accountSelector.helpers,
          getNewShares = _svs$components$marke.getNewShares,
          showIncreaseWarning = _svs$components$marke.showIncreaseWarning;
      getNewShares({
        drawNumber: drawNumber,
        productId: getProductId()
      }, function (error, _ref) {
        var newShares = _ref.newShares,
            newBalance = _ref.newBalance;
        if (error) return _this.handleCheckNewShares(error);

        if (newShares > 0) {
          showIncreaseWarning(newShares, svs.utils.format.Currency(newBalance), _this.model.pay);
        } else {
          _this.model.pay();
        }
      });
    }
  },
  handleCheckNewShares: function handleCheckNewShares(err) {
    if (err) {
      this.log.warn('Could not fetch group, ', err);
    }

    this.model.pay();
  },
  tipsSMPayment: function tipsSMPayment() {
    if (svs.tipset.models.competition.getCompetitionMode()) {
      if (!svs.tipset.models.competition.getCompetitionSignUpMode()) {
        if (svs.tipset.models.competition.getUserHasPlayedCurrentRound()) {
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'games',
            title: 'Spelet kunde inte läggas',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Du har redan lagt ditt Tips-SM för aktuell omgång.'
            }],
            actions: [{
              title: 'OK'
            }]
          }));
        } else {
          if (svs.tipset.models.competition.getDrawIsValidForTipsSM()) {
            if (svs.utils.ns.isNamespace('svs.competition.core.data.tipsSMCompetition')) {
              this.model.payCompetition();
            } else {
              this.model.pay();
            }
          } else {
            svs.components.dialog.api.add(new svs.components.dialog.Confirm({
              branding: svs.components.dialog.branding.SPORT,
              icon: 'help-2',
              title: 'Denna omgång ingår inte i Tips-SM',
              actions: [{
                title: 'OK'
              }]
            }));
          }
        }
      } else {
        this.signUpSingle();
      }
    } else {
      if (svs.tipset.models.competition.getUserHasPlayedCurrentRound()) {
        this.model.pay();
      } else {
        if (svs.core.userSession.isAnonymous() && svs.competition.Helper.drawIsValidForTipsSM(this.model.getCurrentDrawNumber())) {
          svs.components.customer_login.login();
          return;
        }

        if (svs.competition.Helper.userIsParticipatingInTipsSM()) {
          if (svs.competition.Helper.drawIsValidForTipsSM(this.model.getCurrentDrawNumber()) && !svs.competition.Helper.userHasPlayedDraw(this.model.getCurrentDrawNumber()) && this.model.getIsNotMultipleWeeks()) {
            tipssmParticipateDialog({
              productId: getProductId(),
              drawNumber: this.model.getCurrentDrawNumber(),
              competitionId: svs.tipset.models.competition.get('id'),
              onParticipate: this.model.payCompetition,
              onRefuse: this.model.pay
            });
          } else {
            this.model.pay();
          }
        } else {
          if (svs.competition.Helper.drawIsValidForTipsSM(this.model.getCurrentDrawNumber()) && svs.competition.core.data.canRegisterForTipsSM && this.model.getIsNotMultipleWeeks()) {
            this.signUpSingle();
          } else {
            this.model.pay();
          }
        }
      }
    }
  },
  initializeSignUp: function initializeSignUp() {
    if (this.isLoggedIn()) {
      tipssmParticipateDialog({
        productId: getProductId(),
        drawNumber: this.model.getCurrentDrawNumber(),
        competitionId: svs.tipset.models.competition.get('id'),
        onParticipate: this.model.payCompetition,
        onRefuse: this.model.pay
      });
    }
  },
  signUpSingle: function signUpSingle() {
    if (svs.utils.ns.isNamespace('svs.tipset.models.competition')) {
      this.initializeSignUp();
    }
  },
  isLoggedIn: function isLoggedIn() {
    if (!svs.core.userSession.hasRole(roles.PLAYER) && !svs.core.userSession.hasRole(roles.RETAILER)) {
      svs.components.customer_login.login();
    } else {
      return true;
    }
  },
  onAccountSelectorDataChange: function onAccountSelectorDataChange(_ref2) {
    var currentAccount = _ref2.currentAccount;
    var balance = currentAccount ? currentAccount.balance.toString() : this.model.get('userAccountBalace');
    this.model.setAccountBalance(balance);
  },
  renderAccountSelector: function renderAccountSelector() {
    if (svs.components.marketplace && svs.components.marketplace.accountSelector && $('.account-change-holder').length > 0) {
      svs.components.marketplace.accountSelector.render('.account-change-holder');
    }
  },
  onDestroy: function onDestroy() {
    if (svs.components.marketplace && svs.components.marketplace.accountSelector) {
      svs.components.marketplace.accountSelector.helpers.observer.unsubscribe(this.onAccountSelectorDataChange);
    }
  },
  onAttach: function onAttach() {
    if (!this.model.get('isInCompetitionMode')) {
      var marketplace = svs.components.marketplace;

      if (marketplace && marketplace.accountSelector) {
        marketplace.accountSelector.helpers.observer.notify({
          drawNumber: svs.tipset.collections.draws.getCurrentDraw().get('drawNumber'),
          productId: getProductId(),
          userAccountBalance: this.model.get('userAccountBalace')
        });
        this.onAccountSelectorDataChange = this.onAccountSelectorDataChange.bind(this);
        marketplace.accountSelector.helpers.observer.subscribe(this.onAccountSelectorDataChange, {
          emitCurrentValue: true
        });
        this.renderAccountSelector();
      }
    }
  },
  onDomRefresh: function onDomRefresh() {
    this.renderAccountSelector();
  }
});
 })(window);